// src/data/index.js (updated)

import { reactNotes } from "./react";
import { htmlNotes } from "./html";
import { javascriptNotes } from "./javascript"; // <--- NEW IMPORT
import { cssNotes } from "./css";
import { nodejsNotes } from "./nodejs";
import { dockerNotes } from "./docker";
import { gitNotes } from "./git";
import { githubNotes } from "./github";
import { cNotes } from "./c";
import { cPlusNotes } from "./c++";
import { dsaNotes } from "./dsa";
import { pythonNotes } from "./python";
import { javaNotes } from "./java";

// Aggregate all notes into a single array
export const allNotes = [
  ...reactNotes,
  ...htmlNotes,
  ...javascriptNotes, 
  ...cssNotes,
  ...nodejsNotes,
  ...dockerNotes,
  ...gitNotes,
  ...githubNotes,
  ...cNotes,
  ...cPlusNotes,
  ...dsaNotes,
  ...pythonNotes,
  ...javaNotes,
  
  //...spread other note arrays
];

// Optional: Export individual note arrays if needed elsewhere
export { reactNotes, htmlNotes, javascriptNotes };
